<template>
  <div class="main-content">

    <pulse-loader :loading="loading.general" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading.general">
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div>
                <label>Presets выбора стран</label>
                <div class="flex">
                  <multiselect
                    v-model="selectedCountries"
                    :options="$AllCountries"
                    :multiple="true"
                    label="name"
                    track-by="name"
                    placeholder="Выберите страну"
                    select-label="Выбрать"
                    deselect-label="Убрать страну">
                  </multiselect>
                  <LoadingButton
                    :title='selectedCountryGroup !== null ? "Сохранить" : "Добавить"'
                    className="btn btn-outline-success"
                    :onClick="() => addRecord('countryGroups')"
                    :loading="loading.btn.addNewCountryGroupRecord"
                    type="button"
                    :color="$constants.SUCCESS_COLOR"
                  />
                </div>
              </div>
              <div class="mt-1">
                <table class="table mt-0 table-sm">
                  <tbody>
                  <tr v-for="(r,i) in countryGroups">
                    <td><span class="badge badge-primary mr-1" v-for="c in r">{{ c.name }}</span></td>
                    <td align="right">
                      <div class="flex flex_gap_10">
                        <button type="button" @click="selectForEdit('countryGroup', i)" class="btn btn-outline-info">
                          <i class="icon-fa icon-fa-edit"/>
                        </button>
                        <LoadingButton
                          title='<i class="icon-fa icon-fa-remove"/>'
                          className="btn btn-outline-warning"
                          :onClick="() => removeRecord('countryGroups', r, i)"
                          :loading="loading.btn.removeCountryGroup[i]"
                          type="button"
                          :color="$constants.WARNING_COLOR"
                        />
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <label>Дивизионы с авиа доставкой</label>
              <div class="flex">
                <multiselect
                  v-model="selectedDivision"
                  :options="sortArray(Object.values($AllDivisions ?? {}), 'title')"
                  :multiple="true"
                  label="title"
                  track-by="title"
                  placeholder="Выберите дивизион"
                  select-label="Выбрать"
                  deselect-label="Убрать дивизион">
                </multiselect>
                <LoadingButton
                  title='Сохранить'
                  className="btn btn-outline-success"
                  :onClick="() => addRecord('airDeliveryDivisions')"
                  :loading="loading.btn.updateAirDeliveryDivisions"
                  type="button"
                  :color="$constants.SUCCESS_COLOR"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
  </div>
  </div>
</template>
<script>

import Multiselect from 'vue-multiselect'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {
    LoadingButton,
    Multiselect,
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries']
    },
  },
  data() {
    return {
      loading: {
        general: false,
        btn: {
          addNewCountryGroupRecord: false,
          updateAirDeliveryDivisions: false,
          removeCountryGroup: {}
        }
      },
      selectedCountryGroup: null,
      selectedCountries: [],
      selectedDivision: [],
      countryGroups: [],
    }
  },
  created() {
    this.getSettingsRecords()
  },
  methods: {
    selectForEdit(alias, index) {
      switch (alias) {
        case 'countryGroup':
          this.selectedCountryGroup = index;
          this.selectedCountries = this.countryGroups[index];
          break;
      }
    },
    async getSettingsRecords() {
      this.loading.general = true;
      const {data} = await api.index('/settings/general');
      if (data.success) {
        this.countryGroups = data.records.find((r) => r.option === 'countryGroups')?.sub_value ?? [];
        this.selectedDivision = data.records.find((r) => r.option === 'airDeliveryDivisions')?.sub_value ?? [];
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.general = false;
    },
    async addRecord(alias) {
      let action = 'update';
      let record = {};
      let btnLoadingAlias = '';
      switch (alias) {
        case 'airDeliveryDivisions':
          record = this.selectedDivision.map((d) => {
            return {id: d.id, title: d.title}
          })
          btnLoadingAlias = 'updateAirDeliveryDivisions'
          break;
        case 'countryGroups':
          if (this.selectedCountryGroup !== null && this.selectedCountries.length < 2) return;
          record = this.selectedCountries;
          if (this.selectedCountryGroup !== null) {
            record = [...this.countryGroups];
            record[this.selectedCountryGroup] = this.selectedCountries;
          }
          action = this.selectedCountryGroup !== null ? 'update' : 'addNew';
          btnLoadingAlias = 'addNewCountryGroupRecord'
          break;
      }

      this.loading.btn[btnLoadingAlias] = true;
      const {data} = await api.post('/settings/update', {
        option: alias,
        action:
        record
      });
      if (data.success) {
        switch (alias) {
          case 'countryGroups':
            this.countryGroups = data.record?.sub_value ?? [];
            this.selectedCountries = [];
            this.selectedCountryGroup = null;
            break;
          default:
            break;
        }
        toastr['success']('Сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.btn[btnLoadingAlias] = false;
    },
    async removeRecord(alias, record, index) {
      this.$set(this.loading.btn.removeCountryGroup, index, true);
      const {data} = await api.post('/settings/update', {
        option: alias,
        action: 'update',
        record: this.countryGroups.filter((r, i) => i !== index)
      });
      if (data.success) {
        this.countryGroups = data.record?.sub_value ?? [];
        toastr['success']('Сохранено', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.btn.removeCountryGroup[index] = false;
    }
  }
}

</script>

<style scoped>
table.table tr td {
  padding: 5px;
}

.row .col-md-6 {
  padding: 0 8px;
}
</style>
